import { render } from "./DocumentoInput.vue?vue&type=template&id=2ab95f78&ts=true"
import script from "./DocumentoInput.vue?vue&type=script&lang=ts"
export * from "./DocumentoInput.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__